import service from "./service"

import backgroundVerificationResultGrouping from "./background-verification-result-grouping"

export default async (caseId) => {

    const [groupingResult, verificationResult] = await Promise.allSettled([
        backgroundVerificationResultGrouping(),
        service(caseId),
    ])

    const grouping =
        groupingResult.status === 'fulfilled' ? groupingResult.value : null
    const backgroundVerificationResult =
        verificationResult.status === 'fulfilled' ? verificationResult.value : null

    return backgroundVerificationResult
}
